import { Action } from '../../actions';
import {
  firstReferenceFromReferenceList,
  mergeEntities,
  transformObjects,
} from '../../helpers';
import { transformNavigationNotification } from './notification.transformers';

export function navigationNotificationsReducer(state = {}, action: Action) {
  switch (action.type) {
    case 'API_FETCH_SUCCESS':
      if (action.payload.type === 'navigationNotifications') {
        const { result, refList } = action.payload;
        return mergeEntities<'navigationNotifications'>(
          state,
          transformObjects(
            result.hits.hits.map(hit => hit._source),
            transformNavigationNotification,
            refList.pathList[1][0],
          ),
          firstReferenceFromReferenceList(refList),
        );
      }
      return state;
    case 'WS_MESSAGE': {
      const userId = action.payload.toUserId;
      switch (action.payload.type) {
        case 'contest':
        case 'project':
        case 'failingProject':
        case 'xpContest':
          // case 'localJobPosted':
          return state;

        case 'award':
        case 'awardBadge':
        case 'awardCredit':
        case 'awardMilestoneReminder':
        case 'awardReminder':
        case 'awardXp':
        case 'bid':
        case 'completed':
        case 'contestAwardedToEmployer':
        case 'contestAwardedToFreelancer':
        case 'contestEntry':
        case 'contestEntryBoughtToEmployer':
        case 'contestEntryBoughtToFreelancer':
        case 'contestPCBNotification':
        case 'contestPCBNotificationFullView':
        case 'createMilestone':
        case 'denyed':
        case 'draftContest':
        case 'highLtvAnnualDiscount':
        case 'hireMe':
        case 'inviteToContest':
        case 'inviteUserBid':
        case 'invoiceRequested':
        case 'levelup':
        case 'notifyfollower':
        case 'projectRecruiter':
        case 'quickHireProject':
        case 'releaseMilestone':
        case 'requestEndProject':
        case 'requestMilestone':
        case 'requestToRelease':
        case 'serviceApproved':
        case 'serviceProjectEndingSeller':
        case 'serviceProjectPostedSeller':
        case 'serviceRejected':
        case 'signUpFreeTrialUpsell':
        case 'upsellCrowdsourceFinding':
          return mergeEntities<'navigationNotifications'>(
            state,
            transformObjects(
              [action.payload],
              transformNavigationNotification,
              userId,
            ),
            { path: ['navigationNotifications', userId] },
          );

        default:
          return state;
      }
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/es/webapp/src/app/@shared/datastore/navigation/notifications/notifications.reducer.ts